
import { CanActivateFn, Router } from '@angular/router';
import { TokenSessionService } from '@shared/services/token.session.service';
import { inject } from '@angular/core';



export const  notLoggedGuard: CanActivateFn = (route, state) => {
const tokenService  = inject(TokenSessionService);
const router = inject(Router);
if(tokenService.isAuthenticated()){
  return router.navigate(['dashboard']);
}
return true;
};
